import isEmpty from "../../is-Empty";
import validator from "validator";

export const SuperAdminRatingReviewValidation = (data) => {
  let errors = {};

  data.description = !isEmpty(data.description) ? data.description : "";
  data.dinerID = !isEmpty(data.dinerID) ? data.dinerID : "";
  data.mobile_number = !isEmpty(data.mobile_number) ? data.mobile_number : "";

  if (validator.isEmpty(data.description)) {
    errors.description = "Description is required";
  }
  if (validator.isEmpty(data.dinerID)) {
    errors.dinerID = "Diner id is required";
  }
  if (validator.isEmpty(data.mobile_number)) {
    errors.mobile_number = "Phone number is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const SuperAdminPendingRatingReview = (data) => {
  let errors = {};

  data.description = !isEmpty(data.description) ? data.description : "";
  data.mobile_number = !isEmpty(data.mobile_number) ? data.mobile_number : "";

  if (validator.isEmpty(data.description)) {
    errors.description = "Description is required";
  }
  if (validator.isEmpty(data.mobile_number)) {
    errors.mobile_number = "Phone number is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
